import React from "react";

const AboutUs = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>About Headway Spot</h1>

      <p style={styles.paragraph}>
        Headway Spot is a modern project, task, and team management platform built
        for founders, startups, and growing teams who want clarity, focus, and
        speed — without the complexity of traditional enterprise tools.
      </p>

      <p style={styles.paragraph}>
        We believe that building a company should feel organized, collaborative,
        and in control. That’s why we created Headway Spot: a single workspace
        where teams can manage projects, track progress, assign responsibilities,
        share milestones, and stay aligned every day.
      </p>

      <p style={styles.paragraph}>
        Designed with simplicity at its core, Headway Spot gives you powerful
        features such as real-time progress tracking, phases & workflows, task
        automation, investor updates, team management, webhooks, Slack
        integrations, and smart reporting. Whether you’re a solo founder or
        leading a multi-team organization, your entire execution system lives in
        one place.
      </p>

      <h2 style={styles.subheading}>Our Mission</h2>

      <p style={styles.paragraph}>
        Help teams make consistent headway — one task, one milestone, and one
        project at a time.
      </p>

      <p style={styles.paragraph}>
        We’re dedicated to delivering a clean, intuitive, and reliable workspace
        that empowers you to execute faster, collaborate better, and scale your
        work with confidence.
      </p>

      <p style={styles.paragraph}>
        Headway Spot is built and operated by <strong>Funde Technologies</strong>,
        headquartered in AhilyaNagar, Maharashtra. We are committed to continuous
        improvement, transparent pricing, and providing a tool that genuinely
        helps teams do their best work.
      </p>

      <p style={styles.closing}>
        <strong>Welcome to Headway Spot —</strong>
        <br />
        Where ideas turn into progress.
      </p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "40px 20px",
    lineHeight: "1.7",
    color: "#1f2937",
  },
  heading: {
    fontSize: "32px",
    fontWeight: "700",
    marginBottom: "24px",
  },
  subheading: {
    fontSize: "22px",
    fontWeight: "600",
    marginTop: "32px",
    marginBottom: "12px",
  },
  paragraph: {
    fontSize: "16px",
    marginBottom: "16px",
  },
  closing: {
    fontSize: "18px",
    marginTop: "32px",
  },
};

export default AboutUs;